import { render } from "./LiveData.vue?vue&type=template&id=7192adf6&scoped=true"
import script from "./LiveData.vue?vue&type=script&lang=js"
export * from "./LiveData.vue?vue&type=script&lang=js"

import "./LiveData.vue?vue&type=style&index=0&id=7192adf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7192adf6"]])

export default __exports__